import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function clearSelectedEnrollment() {
  return restApiClient.url(API.selectedEnrollment.clear.url).delete()
}
